export enum QuestionSection {
  Questions = 'Questions',
  SoftSkills = 'Soft Skills'
}
